import React, { useEffect } from 'react';
import { Modal } from '@spotify-internal/anchor-ds';
import {
  ButtonTertiary,
  LogoSpotify,
  spacer24,
} from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { useT } from 'i18n/hooks/useT';
import { SpotifyConnectButton } from './SpotifyConnectButton';
import { events, SpotifyConnectComponent } from '../events';

type SpotifyConnectInitialModalProps = {
  onConnectSpotify: () => void;
  onClose: () => void;
  component: SpotifyConnectComponent;
  location: string;
};

const PaddedTitleText = styled.div`
  margin-top: ${spacer24};
`;

const ModalActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  > button {
    width: unset;
  }
`;

export const SpotifyConnectInitialModal = ({
  onConnectSpotify,
  onClose,
  component,
  location,
}: SpotifyConnectInitialModalProps) => {
  const t = useT();

  useEffect(() => {
    events.screenView('connect_spotify_modal', location, component);
  }, [location, component]);

  return (
    <Modal
      isShowingCloseButton
      onClose={onClose}
      aria-labelledby="spotify-connect-initial-modal-title"
    >
      <Modal.Title id="spotify-connect-initial-modal-title">
        <LogoSpotify height={124} width={124} condensed useBrandColor={true} />
        <PaddedTitleText>
          {t(
            'SpotifyConnectInitialModal.Title',
            'Link your Spotify account',
            'Spotify Link Initialization Modal Title'
          )}
        </PaddedTitleText>
      </Modal.Title>
      <Modal.Body>
        {t(
          'SpotifyConnectInitialModal.Body',
          'Unlock new ways of earning, get insights about your listeners and add music from your playlists to episodes.',
          'Spotify Link Initialization message'
        )}
      </Modal.Body>
      <Modal.Footer>
        <ModalActionWrapper>
          <SpotifyConnectButton onConnectSpotify={onConnectSpotify} />
          <ButtonTertiary semanticColor="textBrightAccent" onClick={onClose}>
            {t(
              'SpotifyConnectInitialModal.MaybeLaterLabel',
              'Maybe Later',
              'Exit modal text'
            )}
          </ButtonTertiary>
        </ModalActionWrapper>
      </Modal.Footer>
    </Modal>
  );
};
